/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/prop-types */
/* eslint-disable prefer-template */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react-hooks/exhaustive-deps */
import { Col, message, Image, Modal, Collapse, Spin, Tag } from 'antd';
import { Checkbox, Form, Input, Select } from 'formik-antd';
import { Formik, isEmptyArray } from 'formik';
import { PlusOutlined } from '@ant-design/icons';
import Webcam from 'react-webcam';
import SignatureCanvas from 'react-signature-canvas';
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import errorHandler from '~/Utils/errorHandler';
import { decrypt } from '~/Utils';

import Button from '~/components/Button';
import api from '~/services/api';
import { ModalFooter } from '~/components/Modal';
import FormControl from '~/components/Form/FormControl';
import Row from '~/components/Row';
import { useIsMobile } from '~/Utils/isMob';

import { checklistGroups, photoLabels } from './objects';

const { Panel } = Collapse;
const initial = {
  users_id: null,
  users_name: null,
  assinatura: null,
  freio_pe: 1,
  freio_estacionamento: 1,
  motor_partida: 1,
  limpador_parabrisa: 1,
  lavador_parabrisa: 1,
  buzina: 1,
  farois: 1,
  pisca_alerta: 1,
  setas_dianteiras: 1,
  setas_traseiras: 1,
  luz_freio: 1,
  luz_re: 1,
  luz_placa: 1,
  indicadores_painel: 1,
  cinto_seguranca: 1,
  fechamento_janelas: 1,
  travas_portas: 1,
  alarme: 1,
  triangulo_advertencia: 1,
  macaco: 1,
  chave_roda: 1,
  condicao_pneu: 1,
  calibracao_pneu: 1,
  pneu_estepe: 1,
  vidros: 1,
  portas: 1,
  parachoque_diant: 1,
  parachoque_tras: 1,
  lataria: 1,
  espelhos_retrovisor: 1,
  bancos: 1,
  teto: 1,
  quebra_sol: 1,
  nivel_oleo: 1,
  fluido_freio: 1,
  nivel_agua: 1,
  habilitacao: 1,
  manut_preven: 1,
  vazamentos: 1,
  km_inicial: null,
  km_final: null,
  obs_gerais: null,
  observacoes: [],
};

function Checklist({ visible, onClose, idVeiculo, checklist }) {
  const { t } = useTranslation();
  const isMob = useIsMobile();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initial);
  const [photos, setPhotos] = useState(
    photoLabels.map(label => ({
      nome: label.campo,
      url: '',
      show: true,
    }))
  );
  const [motorist, setMotorist] = useState([]);
  const [vehicle, setVehicle] = useState({});
  const [sigURl, setSigURL] = useState(null);
  const [states, setStates] = useState([]);
  const [cidades, setCidades] = useState([]);
  const sigCanvas = useRef();
  const create = () => {
    const URL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
    setSigURL(URL);
  };
  const address =
    JSON.parse(decrypt(localStorage.getItem('@App:needs'))) !== null &&
    JSON.parse(decrypt(localStorage.getItem('@App:needs')));

  const setDefault = () => {
    setInitialValues(initial);
    setPhotos(photoLabels.map(() => ({ url: '', show: true })));
    setMotorist([]);
    setVehicle({});
    setSigURL(null);
    setStates([]);
    setCidades([]);
  };

  const dataURLtoFile = (dataurl, filename) => {
    if (!dataurl) return null;

    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    const u8arr = new Uint8Array(bstr.length);

    for (let i = 0; i < bstr.length; i += 1) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const handleSave = async values => {
    setLoading(true);
    console.log('Valores do form:', values);
    const allFilled = photos.every(photo => photo.url);

    if (!allFilled) {
      message.error('Todas as imagens são obrigatórias!');
      setLoading(false);
      return;
    }

    if (!sigURl) {
      message.error('Assinatura é obrigatória');
      setLoading(false);
      return false;
    }

    try {
      values.veiculos_id = Number(idVeiculo);
      values.users_id = motorist.id;
      values.assinatura = sigURl;

      if (values?.id && !values?.km_final) {
        message.error('Km final é obrigatório');
        setLoading(false);
        return false;
      }

      const { data } = values?.id
        ? await api.put(`/controle/${values?.controle_id}`, values)
        : await api.post('/controle', values);

      await api.get(`veiculos/hard/${idVeiculo}`);

      const formData = new FormData();

      photoLabels.forEach((item, index) => {
        const base64Url = photos[index].url;

        if (base64Url && base64Url.startsWith('data:image')) {
          const file = dataURLtoFile(base64Url, `${item.campo}.jpg`);
          if (file) {
            formData.append(item.campo, file);
          }
        } else if (base64Url && base64Url.startsWith('http')) {
          formData.append(item.campo, base64Url);
        }
      });
      console.log(data);
      // Dispara a requisição avisando o servidor que é um formulário com arquivos
      await api.post(`/controle/${data?.id}/imagens`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      message.success(t('messages:success'));
      sigCanvas.current.clear();

      onClose();
    } catch (error) {
      errorHandler(error);
      // O modal continua aberto pra ele ver a desgraça do erro e tentar de novo.
    }
    setLoading(false);
  };

  const selecionaCidade = estado => {
    setLoading(true);
    states.map(item => {
      if (item?.sigla === estado) {
        setCidades(item?.cidades);
      }
      return null;
    });
    setLoading(false);
  };

  const motorista = async () => {
    setLoading(true);
    try {
      const { data } = !checklist ? await api.get('/getlogin') : await api.get(`/users/${checklist.users_id}`);
      console.log(data.name);
      setMotorist(data);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const fetchVehicle = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`veiculos/${idVeiculo}`);

      setVehicle(data);
      console.log(initialValues, data);
      if (initialValues?.km_inicial === null && data.last_km) {
        setInitialValues(prev => ({
          ...prev,
          km_inicial: data.last_km,
        }));
      }
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const videoConstraints = {
    facingMode: 'environment',
  };

  const updatePhoto = (index, newData) => {
    setPhotos(oldPhotos => {
      const newPhotos = [...oldPhotos];
      newPhotos[index] = { ...newPhotos[index], ...newData };
      return newPhotos;
    });
  };

  const FotoVeiculo = ({ index, label }) => {
    const photo = photos[index];

    return (
      <Col xl={6} lg={6} md={6} sm={12} xs={12}>
        <span>{label}</span>
        <br />
        {photo.show ? (
          <button
            style={{ backgroundColor: 'white', padding: '20px', margin: '10px' }}
            type="button"
            onClick={() => updatePhoto(index, { show: false })}
          >
            {photo.url ? (
              <Image src={photo.url} />
            ) : (
              <div>
                <PlusOutlined />
                <div>Fotografia</div>
              </div>
            )}
          </button>
        ) : (
          <Modal
            closable
            onCancel={() => updatePhoto(index, { show: true })}
            visible={!photo.show}
            style={{ height: '100%' }}
            footer={null}
          >
            <Webcam
              videoConstraints={videoConstraints}
              audio={false}
              height="100%"
              screenshotFormat="image/jpeg"
              width="100%"
            >
              {({ getScreenshot }) => (
                <Button
                  type="button"
                  color="info"
                  onClick={() => {
                    const imageSrc = getScreenshot();
                    updatePhoto(index, { url: imageSrc, show: true });
                  }}
                >
                  Tirar foto
                </Button>
              )}
            </Webcam>
          </Modal>
        )}
      </Col>
    );
  };

  useEffect(() => {
    if (visible) {
      if (checklist) {
        setInitialValues(checklist);

        if (checklist.images.length > 0) {
          const mergedPhotos = photoLabels.map(label => {
            const found = checklist.images.find(img => img.nome === label.campo);
            return {
              nome: label.campo,
              url: found?.url || '',
              show: found?.show ?? true,
            };
          });
          console.log(mergedPhotos);
          setPhotos(mergedPhotos);
        }
      }

      setStates(address.cities.estados);
      motorista();
      fetchVehicle();
    }
  }, [visible]);

  const getValidationSchema = context =>
    Yup.object().shape({
      km_inicial: Yup.number().required(t('Campo Obrigatório')),
      km_final: Yup.number().when([], () =>
        context?.id
          ? Yup.number()
              .required(t('Campo Obrigatório'))
              .moreThan(Yup.ref('km_inicial'), 'O valor final deve ser maior que o valor inicial')
          : Yup.number().notRequired()
      ),
      estado: Yup.string().required(t('Campo Obrigatório')),
      cidade: Yup.string().required(t('Campo Obrigatório')),
    });

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={getValidationSchema(initialValues)}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={handleSave}
      >
        {({ values, errors, submitForm, isSubmitting, setFieldValue }) => {
          console.log('Formik errors:', errors);
          return (
            <Spin spinning={loading}>
              <Modal
                closable
                title={(checklist ? 'Desmobilizando - ' : 'Mobilizando - ') + vehicle.modelo + '/' + vehicle.placa}
                visible={visible}
                loading={loading || isSubmitting}
                afterClose={setDefault}
                onCancel={onClose}
                width={1000}
                footer={<ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={() => onClose()} />}
              >
                <Form>
                  <Row>
                    <FormControl
                      cols={{ xs: 24, sm: 6 }}
                      field="users_id"
                      error={errors?.users_id}
                      required
                      label={t('Motorista')}
                    >
                      <Select name="users_id" value={motorist?.id} disabled>
                        <Select.Option value={motorist?.id}>{motorist?.name}</Select.Option>
                      </Select>
                    </FormControl>
                    {values?.id ? (
                      <FormControl
                        cols={{ xs: 24, sm: 6 }}
                        field="km_final"
                        error={errors?.km_final}
                        required
                        label={t('KM Final')}
                      >
                        <Input name="km_final" type="number" />
                        <Tag style={{ width: '100%' }}>Km inicial: {values?.km_inicial}</Tag>
                      </FormControl>
                    ) : (
                      <FormControl
                        cols={{ xs: 24, sm: 6 }}
                        field="km_inicial"
                        error={errors?.km_inicial}
                        required
                        label={t('KM Inicial')}
                      >
                        <Input name="km_inicial" type="number" disabled={checklist?.km_inicial} />
                      </FormControl>
                    )}
                    <FormControl
                      cols={{ xs: 12, sm: 6 }}
                      field="estado"
                      error={errors?.estado}
                      required
                      label={t('Estado')}
                    >
                      <Select
                        name="estado"
                        defaultValue={values?.estado || 'Selecione o Estado'}
                        onChange={selecionaCidade}
                        showSearch
                        filterOption={(input, option) => option?.children?.toLowerCase()?.includes(input.toLowerCase())}
                      >
                        {states.map(item => (
                          <Select.Option key={item?.sigla} value={item?.sigla}>
                            {item?.nome}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl
                      cols={{ xs: 12, sm: 6 }}
                      field="cidade"
                      error={errors?.cidade}
                      required
                      label={t('Cidade')}
                    >
                      <Select
                        name="cidade"
                        showSearch
                        filterOption={(input, option) => option?.children?.toLowerCase()?.includes(input.toLowerCase())}
                        defaultValue={values?.cidade || 'Selecione a Cidade'}
                        disabled={isEmptyArray(cidades) && !values?.cidade}
                      >
                        {cidades.map(item => (
                          <Select.Option key={item} value={item}>
                            {item}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormControl>
                  </Row>
                  <Row>
                    <FormControl
                      cols={{ xs: 24 }}
                      field="obs_gerais"
                      error={errors?.obs_gerais}
                      label={t('Observações gerais')}
                    >
                      <Input.TextArea name="obs_gerais" />
                    </FormControl>
                  </Row>
                  <p>Assinale os itens:</p>
                  <Collapse bordered defaultActiveKey={[]}>
                    {checklistGroups?.map((group, index) => (
                      <Panel header={group?.title} key={index + 1}>
                        <Row>
                          <FormControl cols={{ xs: 12 }}>
                            <Checkbox.Group
                              style={{ display: 'flex', flexDirection: 'column' }}
                              name="avarias"
                              value={group?.items?.filter(item => values[item?.value] === 0).map(item => item?.value)}
                              onChange={checkedList => {
                                group?.items?.forEach(item => {
                                  const isChecked = checkedList?.includes(item?.value);
                                  setFieldValue(item?.value, isChecked ? 0 : 1);

                                  const alreadyExists = values?.observacoes?.some(obs => obs?.where === item?.value);

                                  if (isChecked && !alreadyExists) {
                                    // adiciona uma observação vazia ao selecionar
                                    setFieldValue('observacoes', [
                                      ...(values?.observacoes || []),
                                      { where: item?.value, input: '' },
                                    ]);
                                  }

                                  if (!isChecked && alreadyExists) {
                                    // remove a observação ao desmarcar
                                    setFieldValue(
                                      'observacoes',
                                      values?.observacoes?.filter(obs => obs?.where !== item?.value)
                                    );
                                  }
                                });
                              }}
                              options={group?.items.map(item => ({
                                label: item?.label,
                                value: item?.value,
                              }))}
                            />
                          </FormControl>
                          {group?.items
                            .filter(item => values[item?.value] === 0)
                            .map(item => {
                              const obs = values?.observacoes?.find(obs => obs?.where === item?.value);
                              return (
                                <FormControl key={`${item?.value}-obs`} label={`Observação - ${item?.label}`}>
                                  <Input.TextArea
                                    rows={2}
                                    value={obs?.input || ''}
                                    onChange={e => {
                                      const updated = [...(values?.observacoes || [])];
                                      const i = updated?.findIndex(o => o?.where === item?.value);
                                      if (i !== -1) {
                                        updated[i].input = e.target.value;
                                        setFieldValue('observacoes', updated);
                                      }
                                    }}
                                  />
                                </FormControl>
                              );
                            })}
                        </Row>
                      </Panel>
                    ))}
                  </Collapse>
                  <Row gutter={[16, 16]}>
                    {photoLabels?.map((item, index) => (
                      <FotoVeiculo key={item?.campo} index={index} label={item?.label} />
                    ))}
                  </Row>
                  <Row>
                    <FormControl
                      cols={{ xs: 24 }}
                      field="assinatura"
                      error={errors?.assinatura}
                      required
                      label={t('Assinatura')}
                    >
                      <div style={{ position: 'relative', padding: 0, margin: 0, width: '100%' }}>
                        <SignatureCanvas
                          ref={sigCanvas}
                          penColor="black"
                          backgroundColor="grey"
                          onEnd={create}
                          canvasProps={{
                            width: isMob ? 325 : 950,
                            height: 200,
                            className: 'sigCanvas',
                          }}
                        />
                      </div>
                      <Button
                        type="button"
                        onClick={() => {
                          sigCanvas.current.clear();
                          setSigURL(null);
                        }}
                        style={{ width: '100%' }}
                      >
                        Limpar
                      </Button>
                    </FormControl>
                  </Row>
                </Form>
              </Modal>
            </Spin>
          );
        }}
      </Formik>
    </div>
  );
}
export default Checklist;
